import gql from 'graphql-tag';

import { CARD_FRAGMENT } from 'data/fragments/stripe.fragments';

// ⚠️ Ne PAS ajouter `billingInfo` ici : ces champs sont résolus depuis Odoo (`res.partner`), donc chaque
// requête qui les sélectionne attend Odoo et échoue avec lui. Ce fragment alimente le boot de l'app
// (GET_ORGANIZATION dans App.tsx) : il doit rester servi par Mongo/Stripe uniquement. Les infos de
// facturation se chargent à part, via GET_ORGANIZATION_BILLING_INFO (cf. useOrganizationBillingInfo).
export const ORGANIZATION_FRAGMENT = gql`
    fragment OrganizationFragment on Organization {
        _id
        accountManagerId
        attachUsersManually
        cards {
            ...CardFragment
        }
        domains
        acceptedTerms {
            areAccepted
            termsRecordId
            acceptanceDate
        }
        isTest
        maxUsers
        name
        paymentType
        imageUrl
        state
        stripeId
        hasSubscription
    }
    ${CARD_FRAGMENT}
`;

export const BILLING_INFO_FRAGMENT = gql`
    fragment BillingInfoFragment on OrganizationBillingInfo {
        defaultPaymentMethod
        invoiceAddress
        invoiceCity
        invoiceCountry
        invoiceEmail
        invoiceName
        invoicePO
        invoiceVAT
        invoiceSiret
        invoiceZipcode
    }
`;
